import { del, post } from 'utils/api';
import { alert, toast } from 'utils/modal';

export async function updateUsers(changes) {
	const { roleChanges, deletions } = Object.entries(changes).reduce((data, [user, role]) => {
		if (role === 'DELETE') {
			data.deletions.push(del(`/users/${user}`, {}));
			return data;
		}
		data.roleChanges.push({ user_id: user, role });
		return data;
	}, { roleChanges: [], deletions: [] });

	const results = await Promise.allSettled(
		deletions.concat(
			roleChanges.length && post('/users/change-role', { changes: roleChanges })
		)
	);

	if (results.every(result => result.status === 'fulfilled')) {
		toast('Users updated', { icon: 'edit' });
	} else {
		// NOTE: What to do if the requests only partially fail?
		// Also, should this function throw, and keep the users edition modal opened ?
		alert('Sorry, users could not be updated');
	}
}
